import './item-card.scss'

import { defineComponent, PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { Item } from '@skinsoft/types'
import { itemSelectors } from '@skinsoft/selectors'
import { itemTypeFormatters } from '@skinsoft/entity'

import { Touchable } from '../touchable'
import { Description } from './description'
import { Location } from './location'
import { Media } from './media'

export const ItemCard = defineComponent({
    components: {
        sDescription: Description,
        sLocation: Location,
        sMedia: Media,
        sTouchable: Touchable,
    },
    props: {
        focused: {
            required: false,
        },
        item: {
            type: Object as PropType<Item>,
            required: true,
        },
        readonly: {
            default: false,
            required: false,
        },
        displayType: {
            required: false
        }
    },

    template: require('./item-card.html'),
    data() {
        return {
            contentReady: false,
            encounteredError: false,
            validated: false,
            loadingIcon: faCircleNotch,
            itemSelectors,
            descriptionReady: false,
            locationReady: false,
        }
    },
    computed: {
        readableCardType(): TranslateResult {
            return this.$t(
                itemTypeFormatters.getReadableType(this.item.entityType ?? this.item.type)
            )
        },
    },
    methods: {
        onDescriptionReady() {
            this.descriptionReady = true;
            this.processContentReady();
        },
        onLocationReady() {
            this.locationReady = true;
            this.processContentReady();
        },
        processContentReady() {
            this.contentReady = this.descriptionReady && this.locationReady;
        },
    },
})
